var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcondatos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 65,
    fill: "none",
    viewBox: "0 0 66 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65.978,
    height: 64.479,
    fill: "url(#b)",
    fillOpacity: 0.6,
    rx: 11.996
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8ADBFD",
    d: "M48.912 40.645a.436.436 0 0 0-.235-.369.436.436 0 0 0-.452 0c-3.252 2.649-9.37 4.04-15.237 4.04-5.867 0-12.002-1.391-15.237-4.04a.436.436 0 0 0-.452 0 .436.436 0 0 0-.235.369v2.883c0 3.705 7.124 6.705 15.924 6.705s15.924-3 15.924-6.705v-2.883Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8ADBFD",
    d: "M17.064 36.036c0 3.704 7.124 6.705 15.924 6.705s15.924-3 15.924-6.705v-2.883a.436.436 0 0 0-.235-.369.435.435 0 0 0-.452 0c-3.252 2.648-9.37 4.04-15.237 4.04-5.867 0-12.002-1.392-15.237-4.04a.435.435 0 0 0-.452 0 .435.435 0 0 0-.235.369v2.883Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8ADBFD",
    d: "M32.988 29.331c-5.867 0-12.002-1.39-15.237-4.04a.435.435 0 0 0-.452 0 .435.435 0 0 0-.235.269v2.933c0 3.705 7.124 6.705 15.924 6.705s15.924-3 15.924-6.705V25.56a.436.436 0 0 0-.235-.369.435.435 0 0 0-.452 0c-3.252 2.75-9.37 4.14-15.237 4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8ADBFD",
    d: "M32.988 27.655c8.794 0 15.924-3.002 15.924-6.705 0-3.703-7.13-6.705-15.924-6.705-8.795 0-15.924 3.002-15.924 6.705 0 3.703 7.13 6.705 15.924 6.705Z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 63.729,
    height: 62.23,
    x: 1.125,
    y: 1.125,
    stroke: "url(#d)",
    strokeOpacity: 0.7,
    strokeWidth: 2.249,
    rx: 10.871
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 1.104,
    x2: 79.231,
    y1: 0,
    y2: 30.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 1.656,
    x2: 78.507,
    y1: 2.267,
    y2: 31.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EEEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#DCCBFF",
    stopOpacity: 0.764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#39F3FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A87EFF",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h35.988v35.988H0z",
    transform: "translate(14.995 14.245)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 110.963,
    height: 109.464,
    x: -22.493,
    y: -22.493,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11.246
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_433_13517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_433_13517",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcondatos);
export default __webpack_public_path__ + "static/media/icon datos.cb9bd03e8c5141dbce5bf536b89226cb.svg";
export { ForwardRef as ReactComponent };